package com.eladfinish.bible.contest.domain

import com.eladfinish.bible.contest.domain.catalog.BibleCatalog

object BooksRepository {
    private val books = BibleCatalog.books
    val bookNamesHebrew: List<String> = books.map { it.hebrew }
    val bookNamesEnglish: List<String> = books.map { it.trans }
    val numOfChaptersPerBook: List<Int> = books.map { it.numberOfChapters }
    val chumashim: List<String> = bookNamesHebrew.take(5)
}
